module.exports = [{"slNo":1,"honorificValue":"Mr","honorificName":"Mr."},{"slNo":2,"honorificValue":"Ms","honorificName":"Ms."},{"slNo":3,"honorificValue":"Mrs","honorificName":"Mrs."},{"slNo":4,"honorificValue":"Master","honorificName":"Master"},{"slNo":5,"honorificValue":"Miss","honorificName":"Miss"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/paxMapping.json
// module id = 473
// module chunks = 0